import { Col, Typography } from "antd";
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./index.module.css";
import demoUser from "../../../Utils/icons/demoUser.png";

const HeaderComponenet = ({ pageName, setToggleDrawer }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{ backgroundColor: "inherit", marginBottom: 10, marginTop: 10 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 15,
        }}
      >
        <motion.h4
          className={styles.pageName}
          style={{
            fontWeight: 500,
            fontSize: 20,
            lineHeight: "30px",
            height: 30,
            width: 200,
            color: "#005B60",
            margin: "0",
          }}
          whileHover={{ scale: 1.02 }}
        >
          {pageName}
        </motion.h4>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 20,
          }}
        >
          <div
            role="img"
            aria-label="User"
            style={{
              height: 48,
              width: 48,
              borderRadius: "50%",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            <img
              src={demoUser}
              alt=""
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                display: "block",
                pointerEvents: "none",
                userSelect: "none",
              }}
            />
          </div>

          <Col>
            <Typography.Text
              strong
              style={{ display: "block", fontSize: 15, color: "#1f1f1f" }}
            >
              {localStorage.getItem("name") || "User"}
            </Typography.Text>
          </Col>
        </div>
      </div>
    </motion.div>
  );
};

export default HeaderComponenet;
